import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CommunityGuidelines from './pages/CommunityGuidelines';
import './App.css';
import DeleteAccount from './pages/DeleteAccount';
import ChildSafety from './pages/ChildSafety';
import PromptShare from './pages/PromptShare';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/guidelines" element={<CommunityGuidelines />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/child-safety" element={<ChildSafety />} />
        <Route path="/prompt/:promptId" element={<PromptShare />} />
      </Routes>
    </Router>
  );
}

export default App;
